import React, { useContext } from 'react';
import { PageTabsContext } from 'util/PageTabs';
import WebhookStatusTable from './WebhookStatusTable';
import ConnectionStatus from './ConnectionStatus';
import ProductSyncStatusTable from './ProductSyncStatusTable';
import SkuSyncStatusTable from './SkuSyncStatusTable';
import SkuMigrationTable from './SkuMigrationTable';
import SapImportTable from './SapImportTable';
import ProductCachePanel from './ProductCachePanel';
import PlatformLinksPanel from './PlatformLinksPanel';

import './index.less';

const MondayIntegration = () => {
  /**
   * Get the ID of the current tab.
   */
  const tab = useContext(PageTabsContext);

  return (
    <div id="monday-integration-page-content">
      {tab === 'connection-status' ? <ConnectionStatus /> : null}
      {tab === 'webhook-statuses' ? <WebhookStatusTable /> : null}
      {tab === 'product-sync-statuses' ? <ProductSyncStatusTable /> : null}
      {tab === 'sku-sync-statuses' ? <SkuSyncStatusTable /> : null}
      {tab === 'product-cache' ? <ProductCachePanel /> : null}
      {tab === 'platform-links' || tab === 'shopify-links'
        ? <PlatformLinksPanel />
        : null}
      {tab === 'sku-migration' ? <SkuMigrationTable /> : null}
      {tab === 'sap-import' ? <SapImportTable /> : null}
    </div>
  );
};

export default MondayIntegration;
